// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';

import { homeService } from './service';
import * as homeActions from './actions';
import * as types from './actionTypes';

function* homeSaga() {
  const result = yield call(homeService);
  if (result.ok) {
    const home = result.body;

    const {
      title_line1,
      title_line2,
      description,
      video_block_title,
      video_link,
      rating_block_title,
      rating_block_description,
      rating_block_carousel_interval,
      rating_panel,
      carbon_block_title,
      carbon_block_description,
    } = home.items[0];

    let { gallery_image_picker } = home.items[0];

    gallery_image_picker = gallery_image_picker.map((el) => {
      const data = el.image;
      return {
        image: data.meta.download_url,
        title: el.title,
        description: el.description,
      };
    });

    yield put(homeActions.requestPageDataSuccess({
      title_line1,
      title_line2,
      description,
      video_block_title,
      video_link,
      rating_block_title,
      rating_block_description,
      rating_block_carousel_interval,
      rating_panel,
      images: gallery_image_picker,
      carbon_block_title,
      carbon_block_description,
    }));
  }
}

const homeSagas = [
  takeEvery(types.REQUEST_PAGE_DATA, homeSaga),
];

export default homeSagas;
